module.exports = __webpack_public_path__ + "static/media/ZeroLabz.f5f5c376.png";